<button
  id="citeButton"
  mat-flat-button
  class="only-icon"
  [opacTooltip]="'tooltip.cite' | translate"
  [attr.aria-label]="'tooltip.addToList.cite' | translate"
  (click)="openCitationDialog()">
  <span class="odilo-icon" aria-hidden="true">quotes</span>
</button>
